export default "__VITE_ASSET__BKPXTP6T__"